import StyleConstants from "./styles/constants.scss";

export default {
  mobileBreakpoint1: parseInt(StyleConstants["mobile-breakpoint-1"], undefined),
  mobileBreakpoint2: parseInt(StyleConstants["mobile-breakpoint-2"], undefined)
};
export const DEFAULT_LANG = "en-GB";
